import React, { useMemo } from 'react';
import { View, StyleSheet } from 'react-native';
import { Avatar, Text } from 'react-native-paper';
import { useThemeSettings } from '../ThemeProvider';
import { ModalType, useModalStore } from '../store/modalStore';
import { ButtonVariant, CustomButton } from './CustomButton';
import getGlobalStyles from '../globalStyles';
import { useTranslation } from 'react-i18next';

type FaviconStackProps = {
  favicons: string[];
  count: number; // 0 to hide source count
  articleId: string;
  style?: any
};

const FaviconStack: React.FC<FaviconStackProps> = ({ favicons, count, articleId, style }) => {

  const { t } = useTranslation();
  const { theme } = useThemeSettings();
  const gStyles = useMemo(() => getGlobalStyles(theme), [theme]);
  const { setModalShown } = useModalStore();
  const size = 18; // inner avatar size
  const overlap = -8; // negative margin for overlap
  const wrapperSize = size + 2; // allow for 2px border
  const borderColor = theme?.colors?.surfaceBg;
  const backgroundColor = theme?.colors?.surfaceBg;
  const handlePress = () => {
    if (articleId) {
      setModalShown(ModalType.SOURCES, {articleId});
    }
  };
  return (
    <View style={[styles.container, style]}>

      <CustomButton variant={ButtonVariant.TRANSPARENT} labelStyle={{marginHorizontal:0}}
        onPress={handlePress}
      >
        <View style={[{ flexDirection: 'row' }, count !== 0 && gStyles.categoryChip, count !== 0 && { padding: 6 }]}>
          {favicons?.slice(0, 3).map((uri, index) => (
            <View
              key={`${uri}-${index}`}
              style={[
                styles.item,
                {
                  width: wrapperSize,
                  height: wrapperSize,
                  borderRadius: wrapperSize / 2,
                  marginLeft: index === 0 ? 0 : overlap,
                  borderColor,
                  backgroundColor,
                  zIndex: index,
                  flexDirection: 'row'
                },
              ]}
            >
              <Avatar.Image size={size} source={{ uri }} />
            </View>
          ))}
          {count !== 0 && <Text variant='bodyMedium' style={{ color: theme?.colors?.white, verticalAlign: 'top', paddingHorizontal: 5 }}>{t("screens.sources.title", { count })}</Text>}
        </View>
      </CustomButton>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  item: {
    overflow: 'hidden',
    borderWidth: 2,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default FaviconStack;
